export { PrimeNgModule } from './vendors/primeNG/primeNG.module';
